import { z } from 'zod';
/**
 * Corps de `PATCH /admin-user/:id/on-call`. Un booléen mal typé partait
 * jusqu'à la transaction Prisma qui bascule l'astreinte : on le rejette à la
 * frontière.
 */
export const setAdminOnCallSchema = z.object({
    isOnCall: z.boolean(),
});
